<template>
  <v-content>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>{{ $t('login') }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" v-model="valid" @keyup.native.enter="login">
                <v-text-field
                  id="3217d38f"
                  v-model="username"
                  :label="$t('username')"
                  prepend-icon="mdi-account"
                  type="text"
                  :rules="[rules.required]"
                />
                <v-text-field
                  id="984944bf"
                  v-model="password"
                  :label="$t('password')"
                  prepend-icon="mdi-lock"
                  type="password"
                  :rules="[rules.required]"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                id="44b522ae"
                :disabled="!valid"
                color="primary"
                @click="login"
              >
                {{ $t('login') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import users from '../api/users'
import server from '../api/server'
import { showToastError } from '../event-bus'

export default {
  name: 'Login',

  data() {
    return {
      valid: true,
      username: null,
      password: null,
      rules: {
        required: v => !!v || this.$t('validation.requiredField')
      }
    }
  },

  methods: {
    async login() {
      if (!this.$refs.form.validate()) {
        return
      }
      try {
        const currentUser = await users.login(this.username, this.password)
        const versionInfo = await server.getVersionInfo()
        this.$store.commit('setCurrentUser', Object.assign({}, currentUser, { features: versionInfo.allowedFeatures }))
        this.$router.push(this.$route.query.redirect || { name: 'Dashboard' })
      } catch (error) {
        let errorMsg = this.$t('toastMessage.errorWhileRetrievingData')
        if (error.response != null) {
          switch (error.response.data.code) {
            case 'GENERAL':
              errorMsg = '(' + error.response.data.code + ')' + ' ' + error.response.data.message
          }
        }
        showToastError(errorMsg)
      }
    }
  }
}
</script>
